import { z } from 'zod';
import { SelectorType } from '@models/types/components/VenueConfigurations.type';

/**
 * Permisivo A PROPOSITO: nada de `.min()`/`.refine()`/`.url()`/`.uuid()`. Un parseo fallido
 * revierte la CLAVE ENTERA a defaults sin aviso en produccion (`ui-config.validator.ts`, toast
 * solo en Edit mode). Ya le paso a `ActionButtonsSchema` con `.url()`. Obligatoriedad = form Angular.
 *
 * `.default()` en cada campo porque `mergeWithDefaults` no hace spread profundo: es la unica
 * migracion para campos nuevos en `data`.
 */

/** `icon` sin enum/`.catch()`: si no, el '' inicial se reescribiria y el gate de AC#4 fallaria
 *  tras recargar. Id inexistente es inofensivo (`VenueIconComponent` usa `|| ''`). */
export const VenueSelectorSchema = z.object({
  selectorType: z.nativeEnum(SelectorType).catch(SelectorType.Icon), // valor invalido -> Icon, no borra la clave
  icon:         z.string().default(''),
  label:        z.string().default(''),
});

export const VenueConfigurationEntrySchema = VenueSelectorSchema.extend({
  id:        z.string().default(''),
  venueId:   z.string().default(''),
  mapId:     z.string().default(''),
  minimapId: z.string().default(''),
});

/** Descarta elementos no-objeto: un solo `null` (o array anidado, `typeof [] === 'object'`) en el
 *  array no debe hacer fallar la clave entera. */
export const VenueConfigurationEntriesSchema = z.preprocess(
  (raw: unknown): unknown =>
    Array.isArray(raw)
      ? raw.filter((entry: unknown): boolean => !!entry && typeof entry === 'object' && !Array.isArray(entry))
      : raw,
  z.array(VenueConfigurationEntrySchema)
);

export const VenueConfigurationsSchema = z.object({
  enabled:     z.boolean().default(false),
  // `.catch`, no `.default`: un `null` a mano no debe tirar la clave entera (mismo criterio que `selectorType`).
  buttonLabel: z.string().catch(''),
  main:        VenueSelectorSchema.default({
    selectorType: SelectorType.Icon,
    icon:  '',
    label: ''
  }),
  data:        VenueConfigurationEntriesSchema.default([]),
});
